import React, {ReactElement, useState} from 'react';
import HeaderMainBar from './HeaderMainBar';
import HeaderDrawer from './HeaderDrawer';
import {
  applyContentfulLinksSetOrdering,
  getMainBarLinksFromResponse,
  getDrawerLinksFromResponse,
  ContentfulHeaderMenuProp,
} from './headerUtils';

import './Header.scss';

type Props = {
  data: ContentfulHeaderMenuProp[];
  showLinks?: boolean;
  focusMode?: boolean;
};

function HeaderContainer({data, focusMode, showLinks}: Props): ReactElement {
  const [isDrawerOpen, setIsDrawerOpen] = useState<boolean>(false);
  const sortedData = applyContentfulLinksSetOrdering(data);

  const toggleMenu = () => {
    setIsDrawerOpen((current) => !current);
  };

  return (
    <header className="header" data-testid="ui.header">
      <HeaderMainBar
        links={getMainBarLinksFromResponse(sortedData)}
        toggleMenu={toggleMenu}
        focusMode={focusMode}
        showLinks={showLinks}
      />
      {showLinks && <HeaderDrawer links={getDrawerLinksFromResponse(sortedData)} isOpen={isDrawerOpen} />}
    </header>
  );
}

export default HeaderContainer;
